(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
    if (drawer.dataset.initialized === 'true') return
    drawer.dataset.initialized = 'true'

    const getPanel = () => drawer.querySelector('[data-cart-drawer-panel]')
    const getError = () => drawer.querySelector('[data-cart-drawer-error]')

    let lastTrigger = null

    const focusClose = () => {
      drawer.querySelector('.cart-drawer__close')?.focus()
    }

    const setStatus = (text) => {
      const status = drawer.querySelector('[data-cart-drawer-status]')
      if (status) status.textContent = text || ''
    }

    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency,
        }).format(cents / 100)
      } catch (error) {
        return `${(cents / 100).toFixed(2)} ${currency}`
      }
    }

    const loadUpsells = async () => {
      const container = drawer.querySelector('[data-cart-upsells]')
      const baseUrl = drawer.dataset.recommendationsUrl
      if (!container || !baseUrl || !container.dataset.productId) return

      try {
        const params = new URLSearchParams({
          product_id: container.dataset.productId,
          limit: '6',
          intent: 'related',
        })
        const response = await fetch(`${baseUrl}.json?${params}`)
        if (!response.ok) return
        const data = await response.json()

        const exclude = new Set((container.dataset.exclude || '').split(',').filter(Boolean))
        const products = (data.products || []).filter((product) => !exclude.has(String(product.id)))
        if (!products.length) return

        const track = container.querySelector('[data-cart-upsells-track]')
        if (!track) return
        track.textContent = ''

        products.forEach((product) => {
          const card = document.createElement('a')
          card.className = 'cart-upsell-card'
          card.href = product.url

          if (product.featured_image) {
            const image = document.createElement('img')
            const separator = product.featured_image.includes('?') ? '&' : '?'
            image.src = `${product.featured_image}${separator}width=180`
            image.alt = ''
            image.loading = 'lazy'
            image.width = 90
            image.height = 90
            card.append(image)
          } else {
            const placeholder = document.createElement('span')
            placeholder.className = 'cart-upsell-card__placeholder'
            placeholder.setAttribute('aria-hidden', 'true')
            card.append(placeholder)
          }

          const content = document.createElement('span')
          const title = document.createElement('span')
          title.className = 'cart-upsell-card__title'
          title.textContent = product.title
          const price = document.createElement('span')
          price.className = 'cart-upsell-card__price'
          price.textContent = formatMoney(product.price, container.dataset.currency || 'EUR')
          content.append(title, price)
          card.append(content)
          track.append(card)
        })

        container.hidden = false
      } catch (error) {
        /* recommendations are optional — fail silently */
      }
    }

    const setBusy = (busy) => {
      const panel = getPanel()
      if (!panel) return
      if (busy) {
        panel.setAttribute('aria-busy', 'true')
      } else {
        panel.removeAttribute('aria-busy')
      }
    }

    const showError = (message) => {
      const error = getError()
      if (!error) return
      error.textContent = message || drawer.dataset.updateError || ''
      error.hidden = false
    }

    const syncHeader = (count, label) => {
      document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
        badge.textContent = String(count)
        badge.hidden = Number(count) < 1
      })
      document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
        if (label) trigger.setAttribute('aria-label', label)
      })
    }

    const refresh = async () => {
      const sectionId = drawer.dataset.sectionId
      const cartUrl = drawer.dataset.cartUrl
      if (!sectionId || !cartUrl) return

      const separator = cartUrl.includes('?') ? '&' : '?'
      const response = await fetch(`${cartUrl}${separator}section_id=${encodeURIComponent(sectionId)}`, {
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!response.ok) throw new Error(drawer.dataset.updateError || '')

      const html = await response.text()
      const documentFragment = new DOMParser().parseFromString(html, 'text/html')
      const nextDrawer = documentFragment.querySelector('[data-cart-drawer]')
      const currentPanel = getPanel()
      const nextPanel = nextDrawer?.querySelector('[data-cart-drawer-panel]')
      if (!nextDrawer || !currentPanel || !nextPanel) throw new Error(drawer.dataset.updateError || '')

      const hadFocusInside = drawer.contains(document.activeElement) && document.activeElement !== drawer
      currentPanel.replaceWith(nextPanel)
      drawer.dataset.cartCount = nextDrawer.dataset.cartCount || '0'
      drawer.dataset.cartLabel = nextDrawer.dataset.cartLabel || ''
      syncHeader(drawer.dataset.cartCount, drawer.dataset.cartLabel)
      setStatus(drawer.dataset.cartLabel)
      if (drawer.open && (hadFocusInside || document.activeElement === document.body)) focusClose()
      loadUpsells()
      if (drawer.open) document.dispatchEvent(new Event('fuzka:cart-preview-refresh'))
    }

    const open = async (refreshFirst = true) => {
      try {
        setBusy(true)
        if (refreshFirst) await refresh()
        if (!drawer.open) drawer.showModal()
      } catch (error) {
        if (!drawer.open) drawer.showModal()
        showError(error.message)
      } finally {
        setBusy(false)
        if (drawer.open) requestAnimationFrame(focusClose)
        if (!refreshFirst) loadUpsells()
        if (drawer.open) document.dispatchEvent(new Event('fuzka:cart-preview-refresh'))
      }
    }

    const changeLine = async (lineKey, quantity) => {
      const changeUrl = drawer.dataset.changeUrl
      if (!changeUrl) return

      try {
        setBusy(true)
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: lineKey, quantity }),
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || drawer.dataset.updateError || '')
        await refresh()
      } catch (error) {
        showError(error.message)
      } finally {
        setBusy(false)
      }
    }

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault()
        lastTrigger = trigger
        open(true)
      })
    })

    drawer.addEventListener('close', () => {
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus()
    })

    drawer.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-cart-drawer-close]')
      if (closeButton) {
        drawer.close()
        return
      }

      const upsellsNav = event.target.closest('[data-upsells-nav]')
      if (upsellsNav) {
        const track = drawer.querySelector('[data-cart-upsells-track]')
        if (track) {
          const direction = upsellsNav.dataset.upsellsNav === 'next' ? 1 : -1
          track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' })
        }
        return
      }

      const item = event.target.closest('[data-cart-drawer-item]')
      if (!item) return

      const lineKey = item.dataset.lineKey
      const quantityInput = item.querySelector('[data-cart-drawer-quantity]')
      if (!lineKey || !quantityInput) return

      if (event.target.closest('[data-cart-remove]')) {
        changeLine(lineKey, 0)
        return
      }

      const quantityButton = event.target.closest('[data-cart-quantity-action]')
      if (!quantityButton) return
      const current = Number.parseInt(quantityInput.value, 10) || 1
      const change = quantityButton.dataset.cartQuantityAction === 'increase' ? 1 : -1
      changeLine(lineKey, Math.max(1, current + change))
    })

    drawer.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('[data-cart-drawer-quantity]')
      const item = quantityInput?.closest('[data-cart-drawer-item]')
      if (!quantityInput || !item?.dataset.lineKey) return
      const quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1)
      quantityInput.value = String(quantity)
      changeLine(item.dataset.lineKey, quantity)
    })

    window.FuzkaCart = {
      open,
      refreshAndOpen: () => open(true),
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-section]').forEach((section) => {
    const form = section.querySelector('[data-cart-form]')
    const updateButton = section.querySelector('[data-cart-update]')
    const status = section.querySelector('[data-cart-status]')
    if (!form || !updateButton) return

    section.classList.add('is-enhanced')
    let updateTimer

    const queueUpdate = () => {
      window.clearTimeout(updateTimer)
      if (status) status.textContent = section.dataset.updatingLabel || ''
      updateTimer = window.setTimeout(() => updateButton.click(), 350)
    }

    section.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      const wrapper = input.closest('.cart-quantity')
      const decrease = wrapper?.querySelector('[data-cart-quantity-decrease]')
      const increase = wrapper?.querySelector('[data-cart-quantity-increase]')

      const adjust = (change) => {
        const current = Number.parseInt(input.value, 10) || 1
        input.value = String(Math.max(1, current + change))
        queueUpdate()
      }

      decrease?.addEventListener('click', () => adjust(-1))
      increase?.addEventListener('click', () => adjust(1))
      input.addEventListener('change', () => {
        input.value = String(Math.max(1, Number.parseInt(input.value, 10) || 1))
        queueUpdate()
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.collection-main__sort-form input[name="sort_by"]').forEach((input) => {
    input.addEventListener('change', () => input.form.submit())
  })

  document.querySelectorAll('.collection-main').forEach((section) => {
    const grid = section.querySelector('[data-collection-grid]')
    const viewButtons = Array.from(section.querySelectorAll('[data-grid-columns]'))
    if (!grid || !viewButtons.length) return

    const storageKey = 'fuzka-collection-grid-columns'
    let savedColumns = '2'

    try {
      const storedColumns = window.localStorage.getItem(storageKey)
      if (storedColumns === '1' || storedColumns === '2') savedColumns = storedColumns
    } catch {
      savedColumns = '2'
    }

    const setGridColumns = (columns, remember) => {
      grid.dataset.columns = columns
      viewButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.gridColumns === columns))
      })

      if (remember) {
        try {
          window.localStorage.setItem(storageKey, columns)
        } catch {
          return
        }
      }
    }

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => setGridColumns(button.dataset.gridColumns, true))
    })

    setGridColumns(savedColumns, false)
  })

  document.querySelectorAll('.collection-main__toolbar').forEach((toolbar) => {
    let lastScrollY = Math.max(window.scrollY, 0)
    let animationFrame

    const showToolbar = () => {
      toolbar.classList.remove('is-hidden')
      toolbar.removeAttribute('aria-hidden')
      toolbar.removeAttribute('inert')
    }

    const hideToolbar = () => {
      if (toolbar.contains(document.activeElement)) return
      if (toolbar.querySelector('details[open]')) return
      toolbar.classList.add('is-hidden')
      toolbar.setAttribute('aria-hidden', 'true')
      toolbar.setAttribute('inert', '')
    }

    const updateToolbar = () => {
      const currentScrollY = Math.max(window.scrollY, 0)
      const scrollDelta = currentScrollY - lastScrollY

      if (currentScrollY <= 8 || scrollDelta < -4) {
        showToolbar()
      } else if (scrollDelta > 4) {
        hideToolbar()
      }

      lastScrollY = currentScrollY
      animationFrame = null
    }

    window.addEventListener('scroll', () => {
      if (animationFrame) return
      animationFrame = window.requestAnimationFrame(updateToolbar)
    }, { passive: true })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    if (menu.dataset.initialized === 'true') return
    menu.dataset.initialized = 'true'

    const trigger = document.querySelector(`[aria-controls="${menu.id}"]`)
    const closeButton = menu.querySelector('.mobile-menu__close')
    const mobileViewport = window.matchMedia('(max-width: 899px)')

    const closeMenu = () => {
      if (menu.open) menu.close()
    }

    trigger?.addEventListener('click', () => {
      if (!menu.open) menu.showModal()
      closeButton?.focus()
    })

    menu.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
      button.addEventListener('click', closeMenu)
    })

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu)
    })

    menu.addEventListener('close', () => {
      if (document.activeElement === document.body) trigger?.focus()
    })

    mobileViewport.addEventListener('change', (event) => {
      if (!event.matches) closeMenu()
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const track = section.querySelector('[data-gallery-track]')
    const slides = Array.from(section.querySelectorAll('[data-gallery-slide]'))
    const thumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'))
    const counter = section.querySelector('[data-gallery-current]')
    const nameInput = section.querySelector('[data-name-input]')
    const nameCount = section.querySelector('[data-name-count]')
    const nameError = section.querySelector('[data-name-error]')
    const clubPicker = section.querySelector('[data-club-picker]')
    const clubScroll = section.querySelector('[data-club-scroll]')
    const clubGrid = section.querySelector('[data-club-grid]')
    const registryElement = section.querySelector('[data-club-preview-registry]')
    const availablePreviewKeys = registryElement ? new Set(Object.keys(JSON.parse(registryElement.textContent))) : new Set()
    const genericPreview = section.querySelector('[data-generic-preview]')
    const genericName = section.querySelector('[data-generic-name-preview]')
    const genericClubInitial = section.querySelector('[data-generic-club-initial]')
    const genericClubName = section.querySelector('[data-generic-club-name]')
    const prices = Array.from(section.querySelectorAll('[data-product-price], [data-purchase-price]'))
    const quantityInput = section.querySelector('[data-quantity-input]')
    const quantityDecrease = section.querySelector('[data-quantity-decrease]')
    const quantityIncrease = section.querySelector('[data-quantity-increase]')
    const productForm = section.querySelector('.product-buy__form')
    const productInner = section.querySelector('.product-page__inner')
    const gallery = section.querySelector('.product-gallery')
    const buy = section.querySelector('.product-buy')
    const personalizer = section.querySelector('.product-personalizer')
    const personalizationPreview = section.querySelector('.product-personalizer__preview')
    const submitButton = section.querySelector('[data-product-submit]')
    const submitLabel = section.querySelector('[data-product-submit-label]')
    const productError = section.querySelector('[data-product-error]')
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (section.dataset.customizable === 'true' && productInner && productForm && personalizer && gallery && buy) {
      const mobileLayout = window.matchMedia('(max-width: 649px)')
      const arrangeProduct = () => {
        if (mobileLayout.matches) {
          if (clubPicker && clubPicker.parentElement !== personalizer) personalizer.insertBefore(clubPicker, personalizationPreview)
          if (gallery.parentElement !== personalizer) personalizer.appendChild(gallery)
        } else {
          if (gallery.parentElement !== productInner) productInner.insertBefore(gallery, buy)
          if (clubPicker && clubPicker.parentElement !== productForm) productForm.insertBefore(clubPicker, personalizer)
        }
      }
      arrangeProduct()
      mobileLayout.addEventListener('change', arrangeProduct)
    }

    const setGalleryIndex = (index) => {
      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.galleryThumb) === index
        thumb.classList.toggle('is-active', isActive)
        if (thumb.classList.contains('product-gallery__view')) {
          thumb.setAttribute('aria-pressed', String(isActive))
        } else if (isActive) {
          thumb.setAttribute('aria-current', 'true')
        } else {
          thumb.removeAttribute('aria-current')
        }
      })
      if (counter) counter.textContent = String(index + 1).padStart(2, '0')
    }

    const showGalleryIndex = (index) => {
      const slide = slides[index]
      if (!track || !slide) return
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' })
      setGalleryIndex(index)
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.galleryThumb)
        showGalleryIndex(index)
      })
    })

    if (track && slides.length > 1) {
      let scrollTimer
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer)
        scrollTimer = window.setTimeout(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth)
          setGalleryIndex(Math.max(0, Math.min(index, slides.length - 1)))
        }, 80)
      }, { passive: true })
    }

    const nameRequiredMessage = nameError?.textContent || ''
    const syncNameValidity = () => {
      if (!nameInput) return
      const invalidPattern = nameInput.value.length > 0 && nameInput.validity.patternMismatch
      if (invalidPattern) nameInput.setAttribute('aria-invalid', 'true')
      else nameInput.removeAttribute('aria-invalid')
      if (nameError) {
        nameError.textContent = invalidPattern ? nameInput.dataset.previewPatternTitle : nameRequiredMessage
        nameError.hidden = !invalidPattern
      }
    }

    if (nameInput) {
      const updateName = () => {
        if (genericName) genericName.textContent = nameInput.value.trim().toUpperCase() || nameInput.placeholder
        if (nameCount) nameCount.textContent = String(nameInput.value.length)
        syncNameValidity()
      }
      nameInput.addEventListener('invalid', () => {
        nameInput.setAttribute('aria-invalid', 'true')
        if (nameError) {
          nameError.textContent = nameInput.validity.patternMismatch ? nameInput.dataset.previewPatternTitle : nameRequiredMessage
          nameError.hidden = false
        }
      })
      nameInput.addEventListener('input', updateName)
      nameInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || !window.matchMedia('(max-width: 649px)').matches) return
        event.preventDefault()
        if (!nameInput.checkValidity()) {
          nameInput.reportValidity()
          return
        }
        nameInput.blur()
        const target = clubPicker || section.querySelector('[data-club-gallery]:not([hidden])') || section.querySelector('.product-personalizer__preview:not([hidden])') || section.querySelector('.product-gallery')
        window.setTimeout(() => target?.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }), 150)
      })
      updateName()
    }

    if (clubScroll && clubGrid) {
      const updateClubFade = () => {
        const horizontal = section.dataset.customizable === 'true' && window.matchMedia('(max-width: 649px)').matches
        const scrollable = horizontal
          ? clubGrid.scrollWidth - clubGrid.clientWidth > 2
          : clubGrid.scrollHeight - clubGrid.clientHeight > 2
        clubScroll.classList.toggle('is-not-scrollable', !scrollable)
        const atEnd = horizontal
          ? clubGrid.scrollLeft + clubGrid.clientWidth >= clubGrid.scrollWidth - 2
          : clubGrid.scrollTop + clubGrid.clientHeight >= clubGrid.scrollHeight - 2
        clubScroll.classList.toggle('is-at-end', atEnd)
      }

      clubGrid.addEventListener('scroll', updateClubFade, { passive: true })
      window.addEventListener('resize', updateClubFade)
      if ('ResizeObserver' in window) new ResizeObserver(updateClubFade).observe(clubGrid)
      updateClubFade()
      if (section.dataset.customizable === 'true' && window.matchMedia('(max-width: 649px)').matches) {
        const selected = clubGrid.querySelector('[data-club-radio]:checked')?.closest('.club-pick')
        if (selected) clubGrid.scrollLeft = Math.max(0, selected.offsetLeft - clubGrid.offsetLeft - 4)
        updateClubFade()
      }
    }

    if (clubPicker && prices.length) {
      clubPicker.addEventListener('change', (event) => {
        const option = event.target.closest('[data-club-radio]')
        if (!option) return
        if (option?.dataset.price) {
          prices.forEach((price) => {
            price.textContent = option.dataset.price
          })
        }
        if (option?.dataset.club) {
          const selectedClub = option.dataset.club
          const hasPreview = availablePreviewKeys.has(option.dataset.previewKey)
          if (personalizationPreview) personalizationPreview.hidden = hasPreview
          if (genericPreview) genericPreview.hidden = hasPreview
          if (genericClubInitial) genericClubInitial.textContent = selectedClub.charAt(0).toUpperCase()
          if (genericClubName) genericClubName.textContent = selectedClub
          if (nameInput) {
            if (hasPreview) {
              nameInput.pattern = '[A-Za-z]+'
              nameInput.title = nameInput.dataset.previewPatternTitle
            } else {
              nameInput.removeAttribute('pattern')
              nameInput.removeAttribute('title')
            }
            syncNameValidity()
          }
        }
        if (option?.dataset.imageId) {
          const imageIndex = slides.findIndex((slide) => slide.dataset.imageId === option.dataset.imageId)
          if (imageIndex >= 0) showGalleryIndex(imageIndex)
        }
        if (option?.value) {
          const url = new URL(window.location.href)
          url.searchParams.set('variant', option.value)
          window.history.replaceState({}, '', url)
        }
      })
    }

    if (quantityInput) {
      const updateQuantity = (change) => {
        const current = Number.parseInt(quantityInput.value, 10) || 1
        quantityInput.value = String(Math.max(1, current + change))
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
      }

      quantityDecrease?.addEventListener('click', () => updateQuantity(-1))
      quantityIncrease?.addEventListener('click', () => updateQuantity(1))
    }

    productForm?.addEventListener('submit', async (event) => {
      if (!submitButton || submitButton.disabled) return
      if (event.submitter && event.submitter !== submitButton) return
      if (!window.FuzkaCart?.refreshAndOpen || !section.dataset.cartAddUrl) return

      event.preventDefault()
      const initialLabel = submitLabel?.textContent
      submitButton.disabled = true
      submitButton.setAttribute('aria-busy', 'true')
      if (productError) productError.hidden = true
      if (submitLabel && submitButton.dataset.loadingLabel) submitLabel.textContent = submitButton.dataset.loadingLabel

      try {
        const response = await fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm),
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || section.dataset.addError || '')
        await window.FuzkaCart.refreshAndOpen()
      } catch (error) {
        if (productError) {
          productError.textContent = error.message || section.dataset.addError || ''
          productError.hidden = false
        }
      } finally {
        submitButton.disabled = false
        submitButton.removeAttribute('aria-busy')
        if (submitLabel && initialLabel) submitLabel.textContent = initialLabel
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related-products]').forEach((section) => {
    if (section.dataset.initialized === 'true') return
    section.dataset.initialized = 'true'

    const load = async () => {
      const { url, sectionId, productId } = section.dataset
      if (!url || !sectionId || !productId) return

      try {
        const params = new URLSearchParams({
          section_id: sectionId,
          product_id: productId,
          limit: '4',
          intent: 'related',
        })
        const response = await fetch(`${url}?${params}`)
        if (!response.ok) return

        const html = await response.text()
        const fragment = new DOMParser().parseFromString(html, 'text/html')
        const nextContent = fragment.querySelector('[data-related-content]')
        const currentContent = section.querySelector('[data-related-content]')
        if (nextContent && currentContent && nextContent.querySelector('.product-card')) {
          currentContent.replaceWith(nextContent)
        }
      } catch (error) {
        /* keep the server-rendered fallback */
      }
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(load)
    } else {
      setTimeout(load, 200)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('[data-predictive-search]').forEach((wrap) => {
    if (wrap.dataset.initialized === 'true') return
    wrap.dataset.initialized = 'true'

    const input = wrap.querySelector('[data-predictive-search-input]')
    const results = wrap.querySelector('[data-predictive-search-results]')
    if (!input || !results) return

    let timer = null
    let lastQuery = ''

    const hide = () => {
      results.hidden = true
      results.textContent = ''
    }

    const formatMoney = (amount, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency,
        }).format(amount)
      } catch (error) {
        return `${amount} ${currency}`
      }
    }

    const render = (query, products) => {
      results.textContent = ''
      if (!products.length) {
        hide()
        return
      }

      products.slice(0, 6).forEach((product) => {
        const link = document.createElement('a')
        link.className = 'search-suggestion'
        link.href = product.url

        if (product.image) {
          const image = document.createElement('img')
          const separator = product.image.includes('?') ? '&' : '?'
          image.src = `${product.image}${separator}width=130`
          image.alt = ''
          image.loading = 'lazy'
          image.width = 65
          image.height = 65
          link.append(image)
        } else {
          const placeholder = document.createElement('span')
          placeholder.className = 'search-suggestion__placeholder'
          placeholder.setAttribute('aria-hidden', 'true')
          link.append(placeholder)
        }

        const title = document.createElement('span')
        title.className = 'search-suggestion__title'
        title.textContent = product.title

        const price = document.createElement('span')
        price.className = 'search-suggestion__price'
        price.textContent = formatMoney(Number.parseFloat(product.price), wrap.dataset.currency || 'EUR')

        link.append(title, price)
        results.append(link)
      })

      results.hidden = false
    }

    const search = async (query) => {
      try {
        const params = new URLSearchParams()
        params.set('q', query)
        params.set('resources[type]', 'product')
        params.set('resources[limit]', '6')
        params.set('resources[options][unavailable_products]', 'hide')
        const response = await fetch(`${wrap.dataset.url}.json?${params}`)
        if (!response.ok) return
        const data = await response.json()
        if (query !== lastQuery) return
        render(query, data?.resources?.results?.products || [])
      } catch (error) {
        hide()
      }
    }

    input.addEventListener('input', () => {
      const query = input.value.trim()
      lastQuery = query
      clearTimeout(timer)
      if (query.length < 2) {
        hide()
        return
      }
      timer = setTimeout(() => search(query), 250)
    })

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hide()
    })

    document.addEventListener('click', (event) => {
      if (!wrap.contains(event.target)) hide()
    })
  })

  } catch(e) { console.error(e); }
})();
})();
